import { doc, getDoc } from 'firebase/firestore'
import React, { useState } from 'react'

import { CardListItem } from '@components/card-list-item.component'
import { Button } from '@components/mantine/button.component'
import { useLoad } from '@hooks/use-load.hook'
import { db } from '@src/firebase-app'
import { dbNames } from '@utils/constants'
import { getUserFullName } from '@utils/helpers'

type MentorInvitation = Invitation & {
  itemId: string
  invitationEvents: InvitationEvent[]
}

type MentorInvitationCardProps = {
  invitation: MentorInvitation
  handleDecline: (invitation: MentorInvitation) => void
  handleAccept: (invitation: MentorInvitation) => void
}

export const MentorInvitationCard = ({
  invitation,
  handleDecline,
  handleAccept,
}: MentorInvitationCardProps): React.ReactElement => {
  const [working, setWorking] = useState(false)

  const [activity, _activity, activityOpts] = useLoad<Activity | Record<string, never>>(
    {},
    () => {
      return getDoc(doc(db, dbNames.activities, invitation.itemId)).then(w => ({
        id: w.id,
        ...w.data(),
      })) as Promise<Activity>
    },
    [],
  )

  const [activityUser, _setActivityUser, activityUserOpts] = useLoad<
    ActivityUser | Record<string, never>
  >(
    {},
    () => {
      const inviterId = invitation.invitationEvents.at(-1)?.inviterId
      return getDoc(
        doc(db, dbNames.activityUsers, `${invitation.itemId}_${inviterId}`),
      ).then(wu => {
        return wu.data() as ActivityUser
      })
    },
    [invitation],
  )

  function onDecline(e: React.MouseEvent): void {
    setWorking(true)
    handleDecline(invitation)
    e.preventDefault()
  }

  function onAccept(e: React.MouseEvent): void {
    setWorking(true)
    handleAccept(invitation)
    e.preventDefault()
  }

  const loading = activityUserOpts.loading || activityOpts.loading || working

  return (
    <CardListItem
      cardTitle={(activity as Activity).name}
      subTitle={getUserFullName(activityUser)}
      icon="user-circle"
      loading={loading}
      renderRightContent={() => (
        <>
          <Button
            className="mr-2"
            variant="secondary"
            onClick={onDecline}
          >
            Decline
          </Button>
          <Button
            variant="primary"
            onClick={onAccept}
          >
            Accept
          </Button>
        </>
      )}
    />
  )
}
